/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Reducer } from 'redux';
import IAction from '../model/IAction';
import IUserState, { initialUserState } from '../model/IUserState';
import * as USER_ACTIONS from '../actionType/user';

const userReducer: Reducer<IUserState, IAction> = (state: IUserState = initialUserState, action: IAction): IUserState => {
  switch (action.type) {
    /**
     *
     * Auths
     *
     */
    case USER_ACTIONS.LOGIN_FINALLY:
      return {
        ...state,
        isLoggedIn: true,
      };
    case USER_ACTIONS.LOGOUT_FINALLY:
      return initialUserState;

    /**
     *
     * User Data
     *
     */
    case USER_ACTIONS.CHANGE_USER:
      return { ...state, user: action.payload.user };
    case USER_ACTIONS.CHANGE_TRIP_REFERENCES:
      return { ...state, tripReferences: action.payload.tripReferences };
    case USER_ACTIONS.CHANGE_COMPANIONS:
      return { ...state, companions: action.payload.companions };

    /**
     *
     * Loadings
     *
     */
    case USER_ACTIONS.CHANGE_LOADING_USER: {
      return { ...state, loading: { ...state.loading, user: action.payload.loading } };
    }
    case USER_ACTIONS.CHANGE_LOADING_TRIP_REFERENCES: {
      return { ...state, loading: { ...state.loading, tripReferences: action.payload.loading } };
    }
    case USER_ACTIONS.CHANGE_LOADING_COMPANIONS: {
      return { ...state, loading: { ...state.loading, companions: action.payload.loading } };
    }

    /**
     *
     * Errors
     *
     */
    case USER_ACTIONS.SAVE_ERROR: {
      return {
        ...state,
        errors: [
          ...state.errors,
          {
            id: state.errors.length + 1,
            functionName: action.payload.functionName,
            title: action.payload.title,
            message: action.payload.message,
            hide: action.payload.hide,
          },
        ],
      };
    }
    case USER_ACTIONS.HIDE_ERROR: {
      const hideErrorItem = state.errors.find((error) => error.id === action.payload.id);
      if (hideErrorItem) return { ...state, errors: [...state.errors.filter((error) => error.id !== action.payload.id), { ...hideErrorItem, hide: true }] };
      return state;
    }

    /**
     *
     * Default
     *
     */
    default:
      return state;
  }
};

export default userReducer;
